import type { BrandName } from "./types";

/**
 * Which brand the product wears, and in which mode it starts.
 *
 * `brand: null` derives every colour role from `seed`, which defaults to the platform's
 * own accent (`document.colours.pink.violetRed`) — so a new domain gets a coherent
 * palette without touching this file. Naming a brand here instead swaps in the
 * hand-tuned preset from palettes.json.
 */
export const THEME_CONFIG: {
  brand: BrandName | null;
  seed: string | null;
  byHostname: Record<string, BrandName>;
} = {
  brand: null,
  seed: null,

  /**
   * Exact-match hostname overrides, checked before `brand`. This is where a domain
   * claims a hand-tuned preset instead of a derived palette:
   *
   *   byHostname: { "snap4sex.com": "violet", "example.pink": "pink" }
   */
  byHostname: {},
};
